// Turn this device into the GNSS source: watch the browser Geolocation and push each position to
// the server's ingest endpoint, where it flows into the fix hub like any other source. Geolocation
// requires a secure context (HTTPS or localhost) — we detect that up front and surface a clear error
// so the UI can point the user at the https/QR path (mDNS + local TLS, or the cloud domain).
import { ingestFix } from './api';

export type ProviderError = 'insecure' | 'unsupported' | 'denied';

export interface ProviderHandle {
  stop(): void;
}

export function startGeolocationProvider(
  onError: (e: ProviderError) => void,
  onAccuracy?: (m: number) => void,
): ProviderHandle | null {
  if (typeof navigator === 'undefined' || !('geolocation' in navigator)) {
    onError('unsupported');
    return null;
  }
  if (!window.isSecureContext) {
    onError('insecure');
    return null;
  }
  const watchId = navigator.geolocation.watchPosition(
    (pos) => {
      const c = pos.coords;
      onAccuracy?.(c.accuracy);
      // apiFetch attaches the bearer in cloud mode (a plain fetch 401s and the fix never lands).
      void ingestFix({
        timestamp: pos.timestamp,
        lat: c.latitude,
        lon: c.longitude,
        accuracyM: c.accuracy,
        altitude: c.altitude,
        speedMps: c.speed,
        headingDeg: c.heading,
      });
    },
    (err) => {
      onError(err.code === err.PERMISSION_DENIED ? 'denied' : 'unsupported');
    },
    { enableHighAccuracy: true, maximumAge: 1000, timeout: 10000 },
  );
  return { stop: () => navigator.geolocation.clearWatch(watchId) };
}
